import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Cpu } from "lucide-react";

export const Route = createFileRoute("/catalog/devices")({
  component: DevicesCatalog,
});

function DevicesCatalog() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Cpu className="h-5 w-5" /> Catalogue dispositifs
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">LPP · CNAM · Compatibilité IRM</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Dispositifs médicaux</CardTitle>
          <CardDescription>Pacemakers, prothèses, implants · Liste des Produits et Prestations</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Le catalogue s'enrichit depuis l'API /api/radiology/modalities et /api/catalog/devices.
          Page complète en migration vers shadcn — pour l'instant, voir apps/web-app.archived/src/pages/DevicesCatalog.tsx
        </CardContent>
      </Card>
    </div>
  );
}
